import React from 'react';
const IconMiscBoltFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22ZM13 6V11H16L11 18V13H8L13 6Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscBoltFill;